export { default as DefaultPage } from './DefaultPage';
export { default as ShoppingCart } from './ShoppingCart';
export { default as PayType } from './PayType';
export { default as PayWithCode } from './PayWithCode';
export { default as PaySuccess } from './PaySuccess';



// WEBPACK FOOTER //
// ./src/features/pay/index.js